import { useEffect, useState } from "react";
import styles from "./ViewRfqByIdModal.module.scss";
import classNames from "classnames";
import {isEmpty} from "../../../../../TruckEdit/Components/helpers"
import { Loading } from "components/assets/Icons";

const ViewRfqByIdModal = ({ setShowViewRfq, setShowByOrderId, byOrderIdData, showByOrderId }) => {
  const [orderId, setOrderId] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false)
  const handleSubmit = () => {
    if (!orderId.trim()) {
      setError("Order ID is required.");
      return;
    }
    setError("");
    setLoading(true)
    setShowByOrderId(orderId.trim().replace("syl-", ""));
  };

  const handleInputChange = (e) => {
    setOrderId(e.target.value)
    if (error) {
      setError("");
    }
  };
  useEffect(() => {
    if(!isEmpty(byOrderIdData) && byOrderIdData?.error) {
      showByOrderId && setError(byOrderIdData?.error?.details)
      setLoading(false)
    } else {
      byOrderIdData?.rfq && setShowViewRfq(false);
    }
  }, [byOrderIdData])
  
  return (
    <div className={styles.modal}>
      <h2>View RfQ by Order ID</h2>
      <h3>View RfQ by entering Order ID displayed on load board.</h3>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <label htmlFor="order-id">Order Id</label>
        <input
          id="oredr-id"
          type="text"
          placeholder="1046801"
          value={orderId}
          onChange={handleInputChange}
          className={error ? styles.inputError : ""}
        />

        <p className={classNames(styles.error, error ? styles.visible : "")}>{error}</p>
      </form>
      <div className={styles.button}>
        {" "}
        <button
          type="button"
          onClick={() => {
            setError(false)
            setShowViewRfq(false);
            setShowByOrderId(false);
          }}
          className={styles.backButton}
        >
          Back
        </button>
        <button disabled={loading || error} type="button" onClick={handleSubmit} className={styles.viewButton}>
          {loading ? <Loading/>: "View" }
        </button>
      </div>
    </div>
  );
};
export default ViewRfqByIdModal;
